import { gql } from '@apollo/client';

export default gql`
  mutation ReorderMediaItem(
    $courseId: String!
    $subjectId: String!
    $input: ReorderMediaItemInput!
  ) {
    mediaItem(courseId: $courseId, subjectId: $subjectId, input: $input)
      @rest(
        type: "MediaItem"
        path: "courses/{args.courseId}/subjects/{args.subjectId}/videos/reorder"
        method: "PUT"
      ) {
      NoResponse
    }
  }
`;
